import {FlagColor} from '../../../flag/data/flagColor';

export class ChangeFlaggedStatusRequest  {
  id: number;
  flagged: boolean;
  flagColor: FlagColor;
}
